import Swiper from 'swiper';
import nextSvg from '../../../assets/svg/arrow-right.svg';
import prevSvg from '../../../assets/svg/arrow-left.svg';

export default Array.from( document.querySelectorAll( '.media-slider > .media-slider__slides' ) ).map( ( slider ) => {
	const wrapper = slider.querySelector( '.media-slider__slides-wrap' );
	const slides  = wrapper.querySelectorAll( '.media-slider__slide' );

	if ( ! wrapper || ! slides ) {
		return;
	}

	slider.classList.add( 'swiper-container' );
	wrapper.classList.add( 'swiper-wrapper' );
	slides.forEach( slide => slide.classList.add( 'swiper-slide' ) );

	slider.insertAdjacentHTML(
		'beforeend',
		`<nav class="media-slider__nav">
			<div class="swiper-button-prev">${prevSvg}</div>
			<div class="swiper-button-next">${nextSvg}</div>
		</nav>`
	);

	return new Swiper( slider, {
		direction: 'horizontal',
		autoHeight: slider.dataset.autoHeight ? true : false,
		speed: 600,
		spaceBetween: 40,
		loop: false,
		navigation: {
			prevEl: '.swiper-button-prev',
			nextEl: '.swiper-button-next',
		},
		breakpoints: {
			768: {
				spaceBetween: 10,
			}
		},
	} );
} );
